export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  return emailRegex.test(email)
}

export const sanitizeFileName = (fileName: string): string => {
  if (!fileName) return 'Untitled'
  const trimmed = fileName.trim()

  if (!trimmed) {
    return 'Untitled'
  }

  const lastDotIndex = trimmed.lastIndexOf('.')
  const baseName =
    lastDotIndex > 0 ? trimmed.substring(0, lastDotIndex) : trimmed

  if (!baseName || baseName.trim().length === 0) {
    return 'Untitled'
  }

  return trimmed
}
